import user from './extra/user';

export const IS_PPP = process.env.REACT_APP_TYPE === 'POST_PURCHASE_PORTAL';

export const getDomain = () => {
  const hostname = (window.location || {}).hostname;
  if (IS_PPP) {
    const { sellerID, storeID } = user.getPPPIdsFromURL();
    return `${hostname}/${sellerID}/${storeID}`;
  }
  return hostname;
};
